const wholesalerProductIds = {
    'Wholesaler 1': [
        '1-48-231008',
    ],
    'Wholesaler 2': [
        '1-39-281102',
    ],
};

function toggleOrderRowsFor(value) {
    if (value === '') {
        document.querySelectorAll('[data-frozen-snack-product]').forEach((e) => {
            e.setAttribute('data-hidden', false);
            e.querySelector('input').removeAttribute('disabled');
        });
        return;
    }

    const validArticleNumbers = wholesalerProductIds[value];
    document.querySelectorAll('[data-frozen-snack-product]').forEach((e) => {
        if (validArticleNumbers.includes(e.getAttribute('data-frozen-snack-product'))) {
            e.setAttribute('data-hidden', false);
            e.querySelector('input').removeAttribute('disabled');
            return;
        }
        e.setAttribute('data-hidden', true);
        e.querySelector('input').setAttribute('disabled', true);
    });
}

export default function initFronzenSnacksOrderForm() {
    const wholesalerSelect = document.querySelector('[data-frozen-snack-wholesaler-select]');
    if (!wholesalerSelect) {
        return;
    }

    if (wholesalerSelect.value) {
        toggleOrderRowsFor(wholesalerSelect.value);
    }

    wholesalerSelect.addEventListener('change', (e) => {
        toggleOrderRowsFor(e.currentTarget.value);
    });
}
